export default __webpack_public_path__ + "static/media/pizza.e4208fc1.jpg";